import React, {Component} from "react";
import _ from "lodash";
import {connect} from "react-redux";
import { DateTime } from "luxon";
import FormFlowWrapper from "../../theme/wrappers/FormFlowWrapper";
import LoanEstimateCardPrintable from "../../subcomponents/loanEstimates/loanEstimateCardPrintable";
import explanations from "../../../utils/explanations";
import AlertCard from "../../theme/cards/AlertCard";
import Logo from "../../theme/logo/logo";
import formatters from "../../../utils/forms/formatters";
import LogoFooter from '../../theme/logoFooter/logo';
import TelephoneNumber from "../../subcomponents/TelephoneNumber";

class LoanEstimatePrintableScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeDisplay: 'summary',
            loading: true,
            shared_version: false,
            shareModalOpen: false,
            showNoPaceFunderFlag: false,
        };
    }

    generateNoFunderCase = () => {
        const data = this.props.focusedLoanEstimate;
        return (
            <FormFlowWrapper controlWidth>
                {this.state.error && (
                    <AlertCard type="danger" msg={this.state.error} bold/>
                )}

                {/* HANDLE CASE OF NO FUNDERS */}
                {!data.length && !this.props.loaderOn && !this.state.error &&
                    <div className="card m-4 mt-6">
                        <div className="card-content">
                            <div
                                className="is-flex m-4 is-justify-content-center is-align-items-center is-flex-direction-column">

                                <h4 className="is-size-4 has-text-primary mx-6 mb-5" >
                                    Unfortunately, there were no matching Loan Products.
                                </h4>
                                <h4 className="is-size-6 has-text-secondary mx-6" >
                                    We regret that no funder on our platform currently finances projects such as the
                                    one you have described.
                                    While this could change soon, our loan specialists will be able to find a
                                    solution for your needs.
                                    write us at <a href="mailto:admin@cleanfi.com ">admin@cleanfi.com</a> or call us
                                    directly, at <TelephoneNumber />
                                </h4>
                                <div className="buttons mt-5">
                                    <div className="button is-link is-outlined"
                                         onClick={() => window.location = '/my-projects'}>
                                        Edit Project
                                    </div>
                                    <div className="button is-link is-outlined"
                                         onClick={() => window.location = '/'}>
                                        Look up another address
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </FormFlowWrapper>
        )
    }


    renderDisplayedSection = () => {
        let {typeDisplay} = this.state;
        let data = this.props.focusedLoanEstimate;
        let estimates = data.estimates || [];
        let displayable = []
        let explanation = ''

        if (!estimates.length) return;

        if (typeDisplay === 'summary') {
            let types = [
                ...new Set(
                    (data?.estimates || [])
                        .map(d => d?.product?.type)
                        .filter(d => ![null, undefined].includes(d))
                )
            ]
            types.forEach(type => {
                displayable.push((data?.estimates || []).find(d => d.product?.type === type))
            })
            explanation = explanations.summary_loan_estimates

        } else if (typeDisplay === 'PACE' && this.state.showNoPaceFunderFlag) {

            return (
                <div className="mb-4">
                    <AlertCard
                        type="warning"
                        msg={
                            <span>
                                This project is eligible for C-PACE, though we are still working with this program’s administrator to return automated proposals.
                                To get competitive C-PACE proposals for this address,  please call us at <TelephoneNumber className="has-text-link" /> or email <a href='mailto:financing@cleanfi.com'>financing@cleanfi.com</a>.
                            </span>
                        }
                    />
                </div>
            )

        } else {
            displayable = estimates.filter(d => d.product?.type === typeDisplay)
            explanation = explanations[typeDisplay]
        }

        return (
            <div>
                {displayable.map((estimate, idx) =>
                   <LoanEstimateCardPrintable
                   showType={typeDisplay === 'summary'}
                   estimate={estimate}
                   index={idx + 1}
                   hasPriviledges={!this.state.shared_version}
                   onApply={() => this.handleApplyRequest(estimate)}
               />
                )}
            </div>
        )
    }

 
    render() {
        const {loading} = this.state;
        const data = this.props.focusedLoanEstimate;
        if (!loading && (!data?.estimates.length || this.state.error)) return this.generateNoFunderCase();
        
        let displayable = []
        let tempStore = []
        let types = [
            ...new Set(
                (data?.estimates || [])
                    .map(d => d?.product?.type)
                    .filter(d => ![null, undefined].includes(d))
            )
        ]
        types.forEach(type => {
            displayable.push((data?.estimates || []).filter(d => d.product?.type === type))
        })
        return (
            <div className="print-page">
            {Object.keys(displayable).map((key) => {
                return (
                    <div key={key} id={key}>
                        <div className="printable-header">
                            <div className="header-info-container">
                                <div className="printable-logo">
                                    <Logo/>
                                    <LogoFooter style={{justifyContent: 'flex-start', margin: '-1em  0 .5em 0'}}/>
                                </div>
                                <div className="mt-2">
                                    <p><b>Project Name: </b>{data.project_lead.project_name}</p>
                                    <p><b>Project Address: </b>{data.project_lead.address.formatted_address}</p>
                                    <p><b>Project Amount: </b>{formatters.USDCurrency.formatter(data.project_lead.amount)}</p>
                                    <p className="is-italic">Generated {DateTime.now().toISODate()}</p>
                                </div>
                            </div>
                        </div>
                        <h4 className="printable-title"><b>{displayable[key][0].product.type}</b></h4>
                        <div className="printable-wrapper pb-after">
                            {displayable[key].map((dataItem, idx) => {
                                return (
                                    <LoanEstimateCardPrintable
                                    estimate={dataItem}
                                    index={idx + 1}
                                    hasPriviledges={!this.state.shared_version}
                                    onApply={() => this.handleApplyRequest(dataItem)}
                                    />
                                )
                            })}
                            <AlertCard type="info">
                                <p className='is-size-7'>
                                    This document is a financing indicative only, based on rates and product features offered by participating funders at the moment of your inquiry -
                                    This document is not a funding offer, but an indication of the financing options available for projects like yours at the moment of your inquiry.
                                    <span className="has-text-weight-semibold">The property address listed here may not qualify for reasons of valuation, debt ratio, title issues or multiple other factors.</span>
                                    Your actual payments would be based on pre-underwriting findings, the application process, the calendar date the financing agreement is signed,
                                    changes in points and fees associated with this program and financing product at the time of your application, PACE program requirement changes,
                                    and other factors. <span className="has-text-weight-semibold">CleanFi and/or its affiliates and licensees make no representation here about the funding viability of your project.</span>
                                </p>
                            </AlertCard>
                        </div>
                    </div>
                )
             })}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    focusedProject: state.projectLeads.focusedProject,
    focusedLoanEstimate: state.projectLeads.focusedLoanEstimate,
    loaderOn: state.session.globalLoaderOn,
});



export default connect(mapStateToProps)(LoanEstimatePrintableScreen);
 